export default __webpack_public_path__ + "static/media/chain-6.a7687e34.png";